var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import * as React from "react";
import { useAsyncCallback } from "react-async-hook";
import { ErrorAlert } from "../ErrorAlert";
export function ConfirmDialog(props) {
    const { open, onClose, title, confirmTitle = title, cancel, onConfirm, fullWidth = true, icon, color = "primary", children } = props;
    const { loading, error, execute } = useAsyncCallback(onConfirm);
    function handleSubmit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (e.currentTarget.reportValidity()) {
                yield execute();
            }
        });
    }
    return (React.createElement(Dialog, { fullWidth: fullWidth, open: open, onClose: onClose },
        React.createElement(DialogTitle, null, title),
        React.createElement("form", { onSubmit: handleSubmit },
            React.createElement(DialogContent, null, children),
            error && (React.createElement(DialogContent, null,
                React.createElement(ErrorAlert, { error: error }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { type: "submit", color: color, disabled: loading, startIcon: loading ? React.createElement(CircularProgress, { color: color, size: 16, sx: { mx: 0.25 } }) : icon }, confirmTitle),
                React.createElement(Button, { onClick: onClose, color: "inherit" }, cancel)))));
}
//# sourceMappingURL=ConfirmDialog.js.map